import React from "react";
import {
  Dialog,
  DialogFooter,
  PrimaryButton,
  DefaultButton,
  MessageBar,
  MessageBarType,
  Spinner,
} from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";

const styles = mergeStyleSets({
  dialogContent: {
    padding: "2px 0",
  },
  errorMessage: {
    marginTop: "16px",
  },
});

interface SharedDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  title: string;
  subText?: string;
  children: React.ReactNode;
  isSubmitting: boolean;
  disableButtonText?: string;
  confirmButtonText?: string;
  confirmButtonDisabled?: boolean;
  disableMaxWidth?: boolean;
  error?: string | null;
}

const SharedDialog: React.FC<SharedDialogProps> = ({
  isOpen,
  onDismiss,
  onConfirm,
  title,
  subText,
  children,
  isSubmitting,
  disableButtonText = "Cancel",
  confirmButtonText = "Start",
  confirmButtonDisabled = false,
  disableMaxWidth = false,
  error,
}) => {
  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onDismiss}
      dialogContentProps={{
        title,
        subText,
      }}
      modalProps={{
        isBlocking: true,
      }}
      styles={{
        main: {
          maxWidth: disableMaxWidth ? undefined : "600px !important",
        },
      }}
    >
      <div className={styles.dialogContent}>
        {children}

        {error && (
          <MessageBar
            messageBarType={MessageBarType.error}
            className={styles.errorMessage}
          >
            {error}
          </MessageBar>
        )}
      </div>

      <DialogFooter>
        <DefaultButton onClick={onDismiss} disabled={isSubmitting}>
          {disableButtonText}
        </DefaultButton>
        <PrimaryButton
          onClick={onConfirm}
          disabled={isSubmitting || confirmButtonDisabled}
        >
          {isSubmitting ? (
            <>
              <Spinner style={{ marginRight: 8 }} ariaLabel="Loading" />
              Starting...
            </>
          ) : (
            confirmButtonText
          )}
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

export default SharedDialog;
